export const version = "rlp/5.8.0";
//# sourceMappingURL=_version.js.map